// extracted by mini-css-extract-plugin
export default {"modalOverlay":"gJ-z","modalContent":"hJ-z","header":"iJ-z","close":"jJ-z"};